export const STATE_NAME = 'favoriteListings';

export const STORAGE_KEY = 'pendingFavoriteListing';

export const ACTION_PREFIX = '[favorites]';

export const Actions = {
  LOAD_FAVORITES_FAIL: `${ACTION_PREFIX} LOAD_FAVORITES_FAIL`,
};
